<template>
  <div class="notes_datatable">
    <datatable :type="'notes'" :recordType="'contact'" :rowData="notes" :loadingMessage="loadingMessage" :noRowsMessage="noRowsMessage" :columns="columns"></datatable>
  </div>
</template>

<script>
import datatable from "datatables/datatable";

export default {
  name: "contact_notes",
  components: {
    datatable
  },
  props: ['notes', 'notesLoaded'],
  data() {
    return {
      loadingMessage: 'Loading Notes...',
      noRowsMessage: 'No Notes Found',
      columns: [
        { headerName: 'Date', valueGetter: this.noteDate, maxWidth: 150 },
        { headerName: 'Type', field: 'note_type', maxWidth: 150 },
        { headerName: 'Left By', field: 'logged_by_name', maxWidth: 150 },
        { headerName: 'Note', field: 'note_description', minWidth: 200 },
        { headerName: 'Note On', valueGetter: this.noteSubject, maxWidth: 200 },
      ],
    }
  },
  methods: {
    noteDate(params) {
      return this.$options.filters.formatDateTime(params.data.note_updated_at || params.data.note_date);
    },

    noteSubject(params) {
      // if note is against a contact
      if (params.data.contact_id && params.data.contact_name) {
        return `Contact (${params.data.contact_name})`;
      }

      // worker note?
      if (params.data.worker_id && params.data.worker_name) {
        return `Worker (${params.data.worker_name})`;
      }

      return 'Company';
    },
    date_value_getter(params) {
      return this.$options.filters.formatDateTime(params.data.updated_at);
    },

    left_by_vg(params) {
      return params.data.note_log_by ? params.data.note_log_by.first_name + ' ' + params.data.note_log_by.surname : null;
    }
  }
}
</script>

<style scoped lang="scss">
.notes_datatable {
  .full_height_datatable {
    height: calc(100vh - 185px);
  }
}
</style>
